import { Loader } from "../components";
import { useGameweekContext, useSettings } from "../data";
import { DESKTOP_QUERY, LiveBadge, MatchupCard, MatchupsAside, OriginHint, PageHeader, useMediaQuery, WeekNav } from "../ui";
import "./MatchupsScreen.css";

export const MatchupsScreen = () => {
	const { week, maxWeekId, matchups, loading, loadingMessage, error, gameweekLive, matchesLive, secondsToNextFetch, matchesInPlay, gotoWeek } = useGameweekContext();
	const { myEntryId } = useSettings();
	const desktop = useMediaQuery(DESKTOP_QUERY);

	const isMine = (m: (typeof matchups)[number]) => myEntryId != null && (m.home.id === myEntryId || m.away.id === myEntryId);
	// the viewer's own matchup leads the list
	const ordered = [...matchups].sort((a, b) => Number(isMine(b)) - Number(isMine(a)));

	const subtitle = gameweekLive
		? matchesLive
			? `${matchups.length} matchups · ${matchesInPlay} live · refreshing every 60s`
			: `${matchups.length} matchups · awaiting kick-off`
		: "Head-to-head matchups";

	return (
		<>
			<PageHeader
				title={week ? `Gameweek ${week.id}` : "Gameweek"}
				subtitle={subtitle}
				aside={
					<>
						{gameweekLive && !loading && <LiveBadge matchesLive={matchesInPlay} secondsToNextFetch={secondsToNextFetch} waiting={!matchesLive} />}
						<WeekNav weekId={week?.id ?? null} maxWeekId={maxWeekId} onChange={gotoWeek} />
					</>
				}
			/>
			<Loader loading={loading} loadingMessage={loadingMessage} />
			{error && (
				<>
					<p className="error-message">{error}</p>
					<OriginHint />
				</>
			)}
			{!loading && !error && matchups.length === 0 && <p className="muted">No matchups for this gameweek.</p>}
			<div className={desktop ? "matchups-layout with-aside" : "matchups-layout"}>
				<div className="matchup-list">
					{ordered.map((m) => (
						<MatchupCard key={m.id} matchup={m} featured={isMine(m)} />
					))}
				</div>
				{desktop && !loading && <MatchupsAside />}
			</div>
		</>
	);
};
